var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"check-work-body d-flex"},[_c('div',{staticClass:"d-flex-left"},[_c('erp-tree-status',{on:{"node-click":_vm.nodeClick}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex-right"},[_c(_vm.ReportCustomer.customerMenuIndex,{tag:"component"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a436410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Customer/ReportCustomer.vue
// module id = null
// module chunks = 